
import React, { useState, useRef } from "react";
import "./Foodbeveragespromotions.css";
import Campaigns from "./Campaigns";
import Promotiondashbord from './Promotiondashbord';
import CreateCampaign from './CreateCampaign';
import Campaignanlytics from './Campaignanlytics';
import Cuponsfiledata from './Cuponsfiledata';
import Foodaddsvideos from "./Foodaddsvideos";
import CampaignAnalytics from "./CampaignAnalytics";
/* ---------- Main Company Component ---------- */
const FoodPramotions = () => {
    const containerRef = useRef(null); // 👈 add this

    const scrollToTop = () => {
        containerRef.current?.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    const tabs = [
        {
            id: 2,
            name: "CREATE CAMPAIGN",
            component: () => <CreateCampaign title="Create New Campaign" scrollToTop={scrollToTop} />,
        },

        {
            id: 1,
            name: "CAMPAIGNS",
            component: () => <Campaigns title="All Campaigns" />,
        },


        {
            id: 3,
            name: "ANALYTICS",
            component: () => <CampaignAnalytics title="Campaign Analytics" />,
        },
        {
            id: 4,
            name: "Digital Screens",
            component: () => <Foodaddsvideos title="DIGITAL" />,
        },
    ];

    const [activeTab, setActiveTab] = useState(tabs[0].id);
    const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

    return (
        <div className="company-container" ref={containerRef}>
    
    <style>{`
   /* Default (Mobile first) – kuch change nahi */
   .company-scroll-container {
     position: static;
     background: #fff;
   }

   .company-buttons-row {
     display: flex;
     // gap: 10px;
     flex-wrap: wrap;
   }

   .company-button {
     padding: 8px 16px;
     border: none;
     background: #f0f0f0;
     cursor: pointer;
     border-radius: 6px;
     white-space: nowrap;
   }

   .company-button.active {
     background: #e66d33;
     color: #fff;
   }

   /* ✅ Desktop / Laptop only */
   @media (min-width: 769px) {
     .company-scroll-container {
       position: sticky;
       top: 0;
       z-index: 100;
       padding: 10px 0;
     }
   }
 `}</style>

            <div className="company-scroll-container">
                <div className="company-buttons-row">
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            className={`company-button ${activeTab === tab.id ? "active" : ""}`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            {tab.name}
                        </button>
                    ))}
                </div>
            </div>

            <div className="component-display">
                {ActiveComponent && <ActiveComponent />}
            </div>
        </div>
    );
};


export default FoodPramotions;




// import React, { useState } from "react";
// import Foodvendorcoupsdetails from "./Foodvendorcoupsdetails";
// import { Link } from "react-router-dom";
// import Foodcoupons from "./Foodcoupons";
// import Topratingsfood from "./Topratingsfood";
// import Foodadvertisement from "./Foodadvertisement";
// import Foodaddsvideos from "./Foodaddsvideos";
// import Campaigns from "./Campaigns";
// import CampaignAnalytics from "./CampaignAnalytics";
// import "./VendorList.css"

// const FoodPramotions = () => {
//     const [activeTab, setActiveTab] = useState("Coupons");

//     const tabContent = {
//         "Coupons": <Foodcoupons />,
//         // "Vendor List": <Foodvendorcoupsdetails />,
//         // "Vendor Rating": <Topratingsfood />,
//         // "Advertisement": <Foodadvertisement />,
//         "Promotions": <Campaigns />,
//         "Promotions Analytics": <CampaignAnalytics />,
//         "Digital Screens": <Foodaddsvideos />,
//     };

//     return (
//         <div className="container-fluid">
//             <div className="row">
//                 {/* <div className="col-lg-2"></div> */}
//                 <div className="col-lg-12 food-pramotions-data-scroll" style={{ height: "80vh", overflowY: "auto", scrollbarWidth: "none" }} >

//                     <div className="discount-container">
//                         {/* Horizontal tabs - increased by 20% */}
//                         <div
//                             style={{
//                                 display: "flex",
//                                 justifyContent: "flex-start",  // Changed to left alignment
//                                 position: "fixed",
//                                 top: "100px",
//                                 left: "255px",  // Changed from "58%" to a fixed pixel value from the left
//                                 transform: "none",  // Removed the translateX transform that was centering
//                                 gap: "14.4px",
//                                 zIndex: 10,
//                                 width: "auto",
//                                 padding: "14.4px 24px",
//                                 flexWrap: "nowrap",
//                             }}
//                             className="rorr b2"
//                         >
//                             {Object.keys(tabContent).map((label) => (
//                                 <button
//                                     key={label}
//                                     onClick={() => setActiveTab(label)}
//                                     style={{
//                                         border: "none",
//                                         borderRadius: "12px", // +20%
//                                         minWidth: "168px", // +20%
//                                         padding: "12px 19.2px", // +20%
//                                         height: "50.4px", // +20%
//                                         backgroundColor: activeTab === label ? "rgb(230 109 51)" : "#d9d9d9",
//                                         color: activeTab === label ? "#fff" : "#000",
//                                         fontWeight: "bold",
//                                         cursor: "pointer",
//                                         transition: "all 0.3s ease",
//                                         fontSize: "1.14rem", // +20%
//                                         whiteSpace: "nowrap",
//                                         flexShrink: 0,
//                                         boxShadow: activeTab === label ? "0 2.4px 4.8px rgba(177, 92, 214, 0.36)" : "none",
//                                     }}
//                                     onMouseEnter={(e) => {
//                                         if (activeTab !== label) {
//                                             e.target.style.backgroundColor = "#e6e6e6";
//                                             e.target.style.transform = "translateY(-1.2px)"; // +20%
//                                         }
//                                     }}
//                                     onMouseLeave={(e) => {
//                                         if (activeTab !== label) {
//                                             e.target.style.backgroundColor = "#d9d9d9";
//                                             e.target.style.transform = "translateY(0)";
//                                         }
//                                     }}
//                                 >
//                                     {label}
//                                 </button>
//                             ))}
//                         </div>
//                         {/* Tab Content - Scrollable Part */}
//                         <div
//                             style={{
//                                 // height: "95vh",
//                                 overflowY: "auto",
//                                 scrollbarWidth: "none",
//                                 paddingTop: "108px", // +20% from 90px
//                                 borderRadius: "9.6px", // +20%
//                                 marginTop: "-75px",
//                             }}
//                             className="b1"
//                         >
//                             {tabContent[activeTab]}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default FoodPramotions;

